module.exports = __webpack_public_path__ + "static/mo15-af9f04ac7fe1c9d0335810890bf2ddbb.png";